/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Modify
 */
export interface Modify {
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    description?: string;
    /**
     * 
     * @type {any}
     * @memberof Modify
     */
    profile?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    controlId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Modify
     */
    excluded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    parameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    newParameterValue?: string;
    /**
     * 
     * @type {string}
     * @memberof Modify
     */
    statementModification?: string;
}

/**
 * Check if a given object implements the Modify interface.
 */
export function instanceOfModify(value: object): value is Modify {
    return true;
}

export function ModifyFromJSON(json: any): Modify {
    return ModifyFromJSONTyped(json, false);
}

export function ModifyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Modify {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'profile': json['profile'] == null ? undefined : json['profile'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'excluded': json['excluded'] == null ? undefined : json['excluded'],
        'parameterId': json['parameterId'] == null ? undefined : json['parameterId'],
        'newParameterValue': json['newParameterValue'] == null ? undefined : json['newParameterValue'],
        'statementModification': json['statementModification'] == null ? undefined : json['statementModification'],
    };
}

export function ModifyToJSON(json: any): Modify {
    return ModifyToJSONTyped(json, false);
}

export function ModifyToJSONTyped(value?: Modify | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'description': value['description'],
        'profile': value['profile'],
        'controlId': value['controlId'],
        'excluded': value['excluded'],
        'parameterId': value['parameterId'],
        'newParameterValue': value['newParameterValue'],
        'statementModification': value['statementModification'],
    };
}

